export const noSpecialCharacter = /^[^\d$&+,:;=?@#|'<>.^*()%!]+$/g;

export const numberString = /^\d+$/g;
